import { useState } from 'react';

import { useNavigationStack } from '../../../../context/NavigationStackContext';
import {
  useAddUserExercise,
  useDeleteExercise,
  useExerciseCancelPublicRequest,
  useExercisePublicRequest,
} from '../../../../redux/api/exercisesAPI';
import { Paths } from '../../../../shared/paths';
import { IExercise } from '../../../../types/interfaces/exercise';

export function useExerciseList(afterAddToFavoriteAction: () => void) {
  const [deleteExercise] = useDeleteExercise();
  const [publicExercise] = useExercisePublicRequest();
  const [cancelPublicExercise] = useExerciseCancelPublicRequest();
  const [addUserExercise] = useAddUserExercise();
  const [exerciseToDeleteId, setExerciseToDeleteId] = useState<string>(null);
  const [exerciseForPublish, setExerciseForPublish] = useState(null);
  const { navigate } = useNavigationStack();

  function onCopyClick(id: string) {
    navigate(Paths.exercises.toNew({ copyExerciseId: id }));
  }

  function onEditClick(id: string) {
    navigate(Paths.exercises.toEditId(id));
  }

  function onFollowClick(id: string) {
    addUserExercise(id)
      .unwrap()
      .then(() => {
        afterAddToFavoriteAction && afterAddToFavoriteAction();
      })
      .catch((e) => console.log(e));
  }

  function onDeleteClick(id: string) {
    setExerciseToDeleteId(id);
  }

  function onPublishClick(exercise: IExercise) {
    setExerciseForPublish(exercise);
  }

  function onCancelPublishClick(exercise: IExercise) {
    cancelPublicExercise(exercise.id);
  }

  function onDeleteSubmit() {
    deleteExercise(exerciseToDeleteId)
      .unwrap()
      .then(() => setExerciseToDeleteId(null))
      .catch((e) => console.log(e));
  }

  function onPublishSubmit(canCopy: boolean) {
    publicExercise({ exerciseId: exerciseForPublish.id, canCopy })
      .unwrap()
      .then(() => setExerciseForPublish(null))
      .catch((e) => console.log(e));
  }

  return {
    onEditClick,
    onDeleteClick,
    onCopyClick,
    onFollowClick,
    exerciseToDeleteId,
    setExerciseToDeleteId,
    exerciseForPublish,
    setExerciseForPublish,
    onPublishSubmit,
    onDeleteSubmit,
    onPublishClick,
    onCancelPublishClick,
  };
}
